/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

import LevelsLayoutHelper from '../../store/util/levelsLayoutHelper';
import multiAxisLevelLayoutAccessor from '../../store/accessors/multiAxisLevelLayout';

import categoryValidator from './validators/categorizer';
import categorySummaryValidator from './validators/summary';
import fieldsCountValidator from './validators/fieldsCount';
import fieldsPositionValidator from './validators/fieldsPosition';
import measuresCountValidator from './validators/measuresCount';
import measuresPositionValidator from './validators/measuresPosition';
import placementValidator from './validators/placement';
import timeSeriesValidator from './validators/timeseries';

export default function checkAvailableVisualizationTypes(state: any) {
    const { visualizationTypesRegistry } = state;
    const { rows, columns } = multiAxisLevelLayoutAccessor(state);

    const categorizers = LevelsLayoutHelper.getAllCategorizers(columns).concat(LevelsLayoutHelper.getAllCategorizers(rows));

    let defaultCategorizersOnly = true;
    const categorizerFn = (item :any) => {
        defaultCategorizersOnly = defaultCategorizersOnly && LevelsLayoutHelper.isDefaultCategorizer(item);
    };
    _.each(rows, categorizerFn);
    _.each(columns, categorizerFn);

    const columnsInfo = LevelsLayoutHelper.toPlacement(columns);
    const rowsInfo = LevelsLayoutHelper.toPlacement(rows);
    const measuresCount = columnsInfo.measuresCount + rowsInfo.measuresCount;
    const fieldsCount = columnsInfo.fieldsCount + rowsInfo.fieldsCount;

    const placement = {
        column: columnsInfo.placement,
        row: rowsInfo.placement
    };

    const timeSeriesAttr = LevelsLayoutHelper.getTimeSeriesAttributes(rows);
    const hasSummaries = LevelsLayoutHelper.allHasSummaries(columns) && LevelsLayoutHelper.allHasSummaries(rows);

    return Object.keys(visualizationTypesRegistry).map((key: string) => {
        let available = false;
        const { descriptor } = visualizationTypesRegistry[key];

        const passesCategories = categoryValidator(descriptor, categorizers, defaultCategorizersOnly);
        const passesSummary = categorySummaryValidator(descriptor, hasSummaries);
        const passesFieldsCount = fieldsCountValidator(descriptor, fieldsCount);
        const passesFieldsPosition = fieldsPositionValidator(descriptor, placement);
        const passesMeasuresCount = measuresCountValidator(descriptor, measuresCount);
        const passesMeasuresPosition = measuresPositionValidator(descriptor, placement);
        const passesPlacement = placementValidator(descriptor, placement);
        const passesTimeSeries = timeSeriesValidator(descriptor, timeSeriesAttr);

        if (passesCategories
            && passesSummary
            && passesFieldsCount
            && passesFieldsPosition
            && passesMeasuresCount
            && passesMeasuresPosition
            && passesPlacement
            && passesTimeSeries
        ) {
            available = true;
        }

        return {
            ...visualizationTypesRegistry[key],
            available
        }
    });

}
